import React from "react";
import Message from "@/model/interface/Message";
import { Check, CheckCheck, Clock, AlertCircle, ShieldAlert } from "lucide-react";

const CARRIER_FILTERED_ERROR_CODE = "30007";

interface StatusIconProps {
  status: Message["status"];
  errorCode?: string;
}

const StatusIcon: React.FC<StatusIconProps> = ({ status, errorCode }) => {
  switch (status) {
    case "QUEUED":
      return (
        <span title="Queued">
          <Clock className="h-3 w-3 text-muted-foreground" />
        </span>
      );
    case "SENT":
      return (
        <span title="Sent">
          <Check className="h-3 w-3 text-muted-foreground" />
        </span>
      );
    case "DELIVERED":
      return (
        <span title="Delivered">
          <CheckCheck className="h-3 w-3 text-blue-500" />
        </span>
      );
    case "FAILED":
      if (errorCode === CARRIER_FILTERED_ERROR_CODE) {
        return (
          <span title={`Filtered by the carrier as likely spam (error ${errorCode})`}>
            <ShieldAlert className="h-3 w-3 text-destructive" />
          </span>
        );
      }
      return (
        <span title={errorCode ? `Undelivered (error ${errorCode})` : "Undelivered"}>
          <AlertCircle className="h-3 w-3 text-destructive" />
        </span>
      );
    default:
      return null;
  }
};

export default StatusIcon;
